import { render, staticRenderFns } from "./SampleCors.vue?vue&type=template&id=0d302126&"
import script from "./SampleCors.vue?vue&type=script&lang=js&"
export * from "./SampleCors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports